const apiServer = {
  'cabinet.guru.ge': 'webgate.guru.ge',
  'cabinet.24guru.by': 'webgate.24guru.by',
  'cabinet.24ats.by': 'webgate.24guru.by',
  'cabinet.24afisha.by': 'webgate2.24guru.by',
  'cabinet.24guru.ru': 'webgate.24guru.ru',
  'cabinet.24ats.ru': 'webgate.24ats.ru',
  'cabinet.guru.arcom.of.by': 'webgate.arcom.of.by',
  'cabinet.headliner.show': 'webgate.headliner.show',
  'cabinet.minskarena.by': 'abws.minskarena.by',
};

export default {
  baseUrl: `${window.location.protocol}//${apiServer[window.location.host] || apiServer['cabinet.guru.arcom.of.by']}`,
  // baseUrl: apiServer ? 'https://abws.minskarena.by' : '',
  // baseUrl: apiServer ? `https://webgate.guru.ge` : ''
};
